import { Button, Group, Paper, Switch, Text } from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { IconInfoCircle, IconSearch } from "@tabler/icons-react";

export interface ChatBotHistoryToolbarProps {
    withToolRecords: boolean;
    onChangeWithToolRecords: (value: boolean) => void;
    enableMarkdown: boolean;
    onChangeEnableMarkdown: (value: boolean) => void;
    selectedDate: Date | null;
    onChangeSelectedDate: (value: Date | null) => void;
    isLatestMode: boolean;
    onSearchTime: () => void;
    onBackToLatest: () => void;
}

export function ChatBotHistoryToolbar({
    withToolRecords,
    onChangeWithToolRecords,
    enableMarkdown,
    onChangeEnableMarkdown,
    selectedDate,
    onChangeSelectedDate,
    isLatestMode,
    onSearchTime,
    onBackToLatest,
}: ChatBotHistoryToolbarProps) {
    return (
        <>
            <Group mt={10} justify="space-between" align="center">
                <Group gap="sm" align="center">
                    <Switch
                        label="包含工具使用"
                        checked={withToolRecords}
                        onChange={(event) => onChangeWithToolRecords(event.currentTarget.checked)}
                    />
                    <Switch
                        label="Markdown顯示"
                        checked={enableMarkdown}
                        onChange={(event) => onChangeEnableMarkdown(event.currentTarget.checked)}
                    />
                </Group>
                <Group gap="xs" align="center">
                    <DateTimePicker
                        locale="zh-tw"
                        valueFormat="YYYY/MM/DD HH:mm"
                        placeholder="選擇查找時間"
                        value={selectedDate}
                        onChange={(val: Date | string | null) => {
                            const d = typeof val === "string" ? (val ? new Date(val) : null) : val;
                            onChangeSelectedDate(d);
                            if (!d && !isLatestMode) {
                                onBackToLatest();
                            }
                        }}
                        size="xs"
                        w={210}
                        clearable
                    />
                    <Button
                        size="xs"
                        variant="light"
                        leftSection={<IconSearch size={14} />}
                        disabled={!selectedDate}
                        onClick={onSearchTime}
                    >
                        查找
                    </Button>
                    {!isLatestMode && (
                        <Button size="xs" variant="outline" color="blue" onClick={onBackToLatest}>
                            回到最新紀錄
                        </Button>
                    )}
                </Group>
            </Group>

            {!isLatestMode && (
                <Paper p="xs" px="md" mt={10} bg="var(--mantine-color-blue-light)" radius="md">
                    <Group justify="space-between" align="center">
                        <Group gap="xs">
                            <IconInfoCircle size={18} />
                            <Text size="sm">
                                目前正在檢視指定時間紀錄範疇（基準時間：
                                {selectedDate ? selectedDate.toLocaleString() : ""}）
                            </Text>
                        </Group>
                        <Button size="xs" variant="subtle" color="blue" onClick={onBackToLatest}>
                            回到最新紀錄
                        </Button>
                    </Group>
                </Paper>
            )}
        </>
    );
}
